import { createContext, PropsWithChildren, useMemo } from 'react';

import { AccountInfo } from '@azure/msal-browser';
import { AbilityBuilder, AnyAbility, createMongoAbility } from '@casl/ability';
import { createContextualCan } from '@casl/react';

import { defineAbilityFor } from '../../../modules/Permissions';


interface AbilityContextProviderProps {
  account: AccountInfo;
}

export const AbilityContext = createContext<AnyAbility>(
  new AbilityBuilder(createMongoAbility).build(),
);

export const Can = createContextualCan(AbilityContext.Consumer);

export const AbilityContextProvider = ({
  account,
  children,
}: PropsWithChildren<AbilityContextProviderProps>) => {
  if (!account.idTokenClaims?.roles?.length) {
    throw new Error("The current user doesn't have any role assigned.");
  }

  const ability = useMemo(
    () => defineAbilityFor(account.idTokenClaims?.roles || []),
    [account.idTokenClaims?.roles],
  );

  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
};
